"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillStatus = void 0;
var React = __importStar(require("react"));
var helpers_1 = require("../../utils/helpers");
var PillStatus;
(function (PillStatus) {
    PillStatus["ACTIVE"] = "active";
    PillStatus["ERROR"] = "error";
})(PillStatus = exports.PillStatus || (exports.PillStatus = {}));
var Pill = function (_a) {
    var align = _a.align, status = _a.status, style = _a.style, mods = _a.mods, children = _a.children, onClick = _a.onClick, testId = _a.testId;
    var clickable = function () { var _a, _b; return ((_a = children.props) === null || _a === void 0 ? void 0 : _a.type) === 'checkbox' || ((_b = children.props) === null || _b === void 0 ? void 0 : _b.type) === 'radio'; };
    var classes = (0, helpers_1.getClassName)('Pill', align && "Pill-content--" + align, status === PillStatus.ACTIVE && 'Pill--active', status === PillStatus.ERROR && 'Pill--error', mods);
    return (React.createElement("div", { "data-testid": testId || 'pill', className: classes, style: __assign(__assign({}, style), { cursor: clickable() ? 'pointer' : 'default' }), onKeyDown: onClick, onClick: onClick, role: "button", tabIndex: 0 }, children));
};
exports.default = Pill;
